module.exports = __webpack_public_path__ + "static/media/girl-snorkeling.bd1c30d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intros/girl-snorkeling.png
// module id = 967
// module chunks = 0